import Loadable from 'react-loadable';

import { LoadingPage } from 'src/components/react-loadable';

export const RepoSettingsPermissionsLoadable = Loadable({
  loading: LoadingPage,
  loader: () => import('./permissions'),
});
